import { useCurrentContentGraphQlClient } from "./useCurrentContentGraphQlClient.js";
import { useApiRequest } from "../apiRequest/useApiRequest.js";
const useContentApiRequest = () => useApiRequest(useCurrentContentGraphQlClient());
export {
  useContentApiRequest
};
//# sourceMappingURL=useContentApiRequest.js.map
